import {useState} from 'react';

import useAppContext from 'conf/AppContext';
import AlleleFrequencyTable from 'pages/AlleleFrequency/table';
import {compareFreqSources, displayName, uniquePopulations} from 'utils/frequencyUtils';

export default function AlleleFrequencyPopulation({frequencies, popProp = 'ALL'}) {
  const [pop, setPop] = useState(popProp);
  const pops = uniquePopulations(frequencies);
  
  const handlePick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setPop(e.target.value);

    const addr = new URL(document.location.href);
    addr.searchParams.set('pop', e.target.value);
    window.history.pushState({path: addr.pathname}, window.title, addr.toString());
  };

  const popFilter = (
    <div>
      <span className="mr-1 font-weight-bold">Population:</span>
      <select onChange={handlePick} value={pop} className="ml-2">
        {pops.map((p) => <option value={p} key={p}>{displayName(p)}</option>)}
      </select>
    </div>
  );
  
  return (
    <div>
      <AlleleFrequencyTable frequencies={frequencies} pop={pop} customFilters={popFilter} />
    </div>
  );
}
